import { render, staticRenderFns } from "./verificationList.vue?vue&type=template&id=4d8e7b3e&scoped=true&"
import script from "./verificationList.vue?vue&type=script&lang=js&"
export * from "./verificationList.vue?vue&type=script&lang=js&"
import style0 from "./verificationList.vue?vue&type=style&index=0&id=4d8e7b3e&prod&lang=less&scoped=true&"
import style1 from "./verificationList.vue?vue&type=style&index=1&id=4d8e7b3e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e7b3e",
  null
  
)

export default component.exports